import React from "react";
import { Switch, Route } from "react-router-dom";

import NotFound from '../NotFound';
import Dashboard from './Dashboard';
import Login from "../../partials/Login";
import Profile from "../users/Profile";
import Search from "../users/Search";
import Spot from "./spots/Spot";
import Author from "./authors/Author";
import Book from "./books/Book";
import Borrow from "./borrows/Borrow";
import Repport from "./reports/Report";

function handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }
function RouterPage(){

    return(
        <Switch>
            {
                handleCheck("Afficher bibliothèque") == true && (
                    <Route exact path="/" component={Dashboard} />
                )
            }
            
            {
                handleCheck("Afficher emplacement") == true && (
                    <Route  path="/spots" component={Spot} />
                )
            }

            {
                handleCheck("Afficher auteur") == true && (
                    <Route  path="/authors" component={Author} />
                )
            }

            {
                handleCheck("Afficher livre") == true && (
                    <Route  path="/books" component={Book} />
                )
            }

            {
                handleCheck("Afficher emprunt") == true && (
                    <Route  path="/borrows" component={Borrow} />
                )
            }

            {
                handleCheck("Afficher rapport") == true && (
                    <Route  path="/repports" component={Repport} />
                )
            }
            
            <Route  path="/search/:search" component={ Search } />
            <Route  path="/get/:user_id" component={ Login } />
            <Route  path="/login" component={ Login } />
            <Route  path="/profile" component={Profile} />
            <Route component={NotFound} />
        </Switch>
    )
}

export default RouterPage;
